
import {createSelector} from "reselect";
import type {TStore} from 'modules/types/store';

const getState = ({contextualPrompt}: TStore) => contextualPrompt;

export const getContextualPromptData = createSelector(getState, (state) => state.prompt);

export const getContextualPromptIsOpen = createSelector(getState, (state) => state.isOpen);
